import React from 'react';

class Header extends React.Component {
  render() {
    return (
      <header>
        <h1 className='movie-card-header'>
          Movie Cards Library
        </h1>
      </header>
    );
  }
}

export default Header;
